import { useInfiniteNames } from '@ukpostbox/client-data';
import { GetPagedArrayIndexByKeyValue } from '@ukpostbox/helpers';
import React, { useEffect, useRef } from 'react';
import { useTranslation } from '@ukpostbox/frontend-framework';
import { SearchTypesType } from '../SearchControlTypes';
import { NamesComboBox } from '../../NamesComboBox';

function SearchMailNames(props: SearchTypesType) {
	const { t } = useTranslation();
	const { data, error, status } = useInfiniteNames();

	const inputRef = useRef<HTMLInputElement | null>(null);

	useEffect(() => {
		if (inputRef.current) {
			inputRef.current.value = props.searchParams?.get('incomingRecipientNameIds')
				? (props.searchParams.get('incomingRecipientNameIds') as string)
				: '';
		}
	}, [props.searchParams]);

	return (
		<NamesComboBox
			name='incomingRecipientNameIds'
			control={props.formMethods.control}
			defaultValues={
				props.searchParams?.get('incomingRecipientNameIds')
					? [props.searchParams?.get('incomingRecipientNameIds') as string]
					: undefined
			}
			conditionalReset={props.searchParams?.get('incomingRecipientNameIds') === null}
			onChangeCallback={(e) => {
				let label = t('mailboxes.filter.counts.names', { count: e.length });

				if (e.length === 1 && data) {
					const indexes = GetPagedArrayIndexByKeyValue(data as any, 'id', e[0]);
					label = indexes
						? `${t('labels.name')}: ${data?.pages[indexes?.pageIndex].data[indexes?.itemIndex].name}`
						: label;
				}

				console.log('name label', label);
			}}
		/>
	);
}

export { SearchMailNames };
